import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function RoleGuard({ allowedRoles, children, fallback = '/manage/dashboard' }) {
    const { user, authLoading } = useAuth();

    if (authLoading || !user) return null;

    if (!allowedRoles.includes(user.role)) {
        return <Navigate to={fallback} replace />;
    }

    return children;
}

export default RoleGuard;
